import React from 'react';
import { FDBox, FDDeleteButton, FDStack } from '@facet-wealth/design';
import TitleSection from 'Views/Page/Content/Modal/Components/TitleSection';
import MetaFormFields from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/MetaFormFields';
import WizardStepDeleteButton
  from 'Views/Page/Content/Templates/WizardTemplates/WizardStepTemplate/Content/WizardStepDeleteButton';
import RelationshipLinks from 'Views/Page/Content/Modal/Layouts/DefaultStep/Layout/RelationshipLinks';
import WhatIfStepNavigator from 'Views/Page/Content/Modal/Components/WhatIfStepNavigator';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import fr from 'facet-rest';

const ManageFacetPlanMoneyMovementDetailsStepLayout = () => {
  const { loadModalCollectionByLink, setModalCollection, clearModalCollection } = useModalContext();
  const { loadPageContentLink } = usePageContentContext();

  const {
    resource,
    onSubmit,
    saving,
  } = useMetaLayoutContext();

  const previousLink = resource.relationship(fr.relationships.previousLink.name)?.link('related');
  async function handleDelete() {
    return resource.delete();
  }

  const onDeleteSuccess = async (resp) => {
    if (resp.isNoContent()) {
      clearModalCollection();
    } else {
      setModalCollection(resp);
    }
  };

  const handleSubmit = async () => {
    const resp = await onSubmit();

    // This means an error happened. so there is no point continuing
    if (!resp) {
      return resp;
    }

    const [respResource] = resp;

    if (respResource.relationship(fr.relationships.pageRefresh.name)) {
      loadPageContentLink(respResource.relationship(fr.relationships.pageRefresh.name).link('related'));
    }

    return resp;
  };

  const DeleteButton = resource.meta().action('DELETE') ? (<WizardStepDeleteButton
    onDelete={handleDelete}
    onDeleteSuccess={onDeleteSuccess}
    dialogProps={{
      title: 'Are you sure?',
      message: 'Removing this item will delete all of its information. This cannot be undone.',
      cancelLabel: 'Nevermind',
      confirmLabel: 'Remove',
    }}
  />) : null;

  return (
    <FDBox>
      <TitleSection />
      <MetaFormFields
        resource={resource}
      />
      <FDStack justifyContent={'center'} width={'100%'}>
        {resource.withRelationship(
          fr.relationships.deleteAUM.name,
          (rel) => {
            return (
              <FDDeleteButton
                onClick={() => loadModalCollectionByLink(rel.link('related').url())}
              />
            );
          },
          () => DeleteButton,
        )}
      </FDStack>
      <FDBox paddingY={1}>
        <RelationshipLinks resource={resource} />
      </FDBox>
      <WhatIfStepNavigator
        isLoading={saving}
        onNext={(resource.meta().canSubmit()) ? handleSubmit : null}
        onPrevious={(previousLink) ? () => {
          loadModalCollectionByLink(previousLink.url());
        } : null}
      />
    </FDBox>
  );
};

ManageFacetPlanMoneyMovementDetailsStepLayout.defaultProps = {};

ManageFacetPlanMoneyMovementDetailsStepLayout.propTypes = {};

export { ManageFacetPlanMoneyMovementDetailsStepLayout };
